/**
 * Created by khanhduong on 11/9/17.
 */
import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function subscribeReducer(state = initialState.supportTicketReducer, action) {
    switch (action.type) {
        case types.GET_SUPPORT_TICKET_NEW_COUNT: {
            return state.set('supportTicketNewCount', action.count);
        }

        case types.UPDATE_REF_TICKET_DETAIL: {
            return state.set('refDetailTicket', action.data);
        }

        case types.SHOW_LIST_SUPPORT_TICKET_MODAL: {
            return state.set('isShowListSupportTicketModal', true);
        }

        case types.HIDE_LIST_SUPPORT_TICKET_MODAL: {
            return state.set('isShowListSupportTicketModal', false);
        }

        case types.GET_CATEGORY_CONTACT_SUCCESS: {
            return state.set('categoryContact', action.data);
        }

        case types.GET_LIST_SUPPORT_TICKET_REQUEST: {
            return state.set('isLoadingListSupportTickets', true);
        }

        case types.GET_LIST_SUPPORT_TICKET_SUCCESS: {
            const isHasMore = action.param && action.param.size === action.data.length;
            return state
                .set('isLoadingListSupportTickets', false)
                .set('isLoadedListSupportTickets', true)
                .set('page', action.param ? action.param.page + 1 : 1)
                .set('isHasMore', isHasMore)
                .set('listSupportTickets', action.data);
        }

        case types.GET_LIST_SUPPORT_TICKET_FAILED: {
            return state
                .set('isLoadingListSupportTickets', false)
                .set('isHasMore', false)
                .set('page', 1)
                .set('isLoadedListSupportTickets', true)
                .set('listSupportTickets', []);
        }

        case types.GET_DETAIL_SUPPORT_TICKET_REQUEST: {
            return state.set('isLoadingDetailSupportTicket', true);
        }

        case types.GET_DETAIL_SUPPORT_TICKET_SUCCESS: {
            const {listSupportTickets} = state;
            state = state.set('isLoadingDetailSupportTicket', false);
            if (
                action.index !== null &&
                action.index !== undefined &&
                listSupportTickets &&
                listSupportTickets[action.index]

            ) {
                if (listSupportTickets[action.index].newCount > 0) state = state.setIn(['listSupportTickets', action.index, 'newCount'], 0);
                state = state.setIn(['listSupportTickets', action.index, 'status'], action.data.ticketStarter.status);
            }
            //  console.log(state.listSupportTickets)
            return state.set('selectedTicketDetail', action.data);
        }

        case types.GET_DETAIL_SUPPORT_TICKET_FAILED: {
            state = state.set('isLoadingDetailSupportTicket', false);
            return state.set('selectedTicketDetail', {});
        }

        case types.RESET_DETAIL_SUPPORT_TICKET_SUCCESS: {
            return state.set('selectedTicketDetail', {});
        }

        case types.UPDATE_LAST_MESSAGE_SELECTED_SUPPORT_TICKET_SUCCESS: {
            const listSupportTickets = state.listSupportTickets.asMutable() || [];
            const indexTicket = listSupportTickets.findIndex(ticket => ticket.ticketRef === action.ticketRef);
            if (indexTicket !== -1) {
                state = state.setIn(['listSupportTickets', indexTicket, 'date'], action.data.date);
                return state.setIn(['listSupportTickets', indexTicket, 'message'], action.data.message);
            }
            return state;
        }

        // case types.GET_SUPPORT_TICKET_NEW_COUNT: {
        //   return state.set("supportTicketNewCount", action.count);
        // }
        default:
            return state;
    }
}
